import classNames from 'classnames'
import i18n from 'i18next'

import { SVGImageCurrentColor } from 'utils/svgHelper'
import toolbarSecureSend from 'assets/images/toolbar-secure-send.svg'

import styles from './style.module.scss'

interface SecurityWarningBannerProps {
  secureSendExpired: string | null
  onEdit: () => void
  onDiscard: () => void
}

const SecurityWarningBanner = ({
  secureSendExpired,
  onEdit,
  onDiscard,
}: SecurityWarningBannerProps) => {
  const formattedDate = secureSendExpired
    ? new Date(secureSendExpired).toLocaleDateString(i18n.language || 'en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    : ''

  return (
    <div className={classNames(styles.secureBanner)}>
      <div
        className={classNames(styles.secureBannerIcon)}
        style={{ color: '#FD4C45', width: 20, height: 20 }}
      >
        <SVGImageCurrentColor src={toolbarSecureSend} alt="secure send" />
      </div>
      <div className={classNames(styles.secureBannerMessages)}>
        <span className={classNames(styles.secureBannerTitle)}>
          {i18n.t('secureSend.expiresOn', { date: formattedDate })}
        </span>
        <span className={classNames(styles.secureBannerDesc)}>
          {i18n.t('secureSend.confidentialMessage')}
        </span>
      </div>
      <div className={classNames(styles.secureBannerButtons)}>
        <button type="button" onClick={onEdit}>
          {i18n.t('secureSend.edit')}
        </button>
        <button type="button" onClick={onDiscard}>
          {i18n.t('secureSend.discard')}
        </button>
      </div>
    </div>
  )
}

export default SecurityWarningBanner
